/**
 * Portal.js
 *
 * Copyright (c) apploft. GmbH
 */

import React, {useReducer} from 'react';
import {
  LoginForm,
  stringMatching,
  useStrings,
  useColors,
} from 'apploft-cloud-forms';
import {APIDefinition} from 'apploft-cloud-client';
import {authorize} from './PortalEventSymbol';
import {reducer, init} from './PortalState';
import {authorizing, unauthorized, authorized} from './PortalStateSymbol';
import EndPointBrowser from '../EndPointBrowser/EndPointBrowser';
import './Portal.css';

function Message(string) {
  return (
    <div className="portal">
      <h2>{string}</h2>
    </div>
  );
}

function Login({dispatch, api, strings}) {
  return (
    <div className="portal">
      <LoginForm
        className="loginForm"
        onSubmit={formData => {
          dispatch({event: authorize, payload: {formData, dispatch, api}});
        }}
        strings={strings}
      />
    </div>
  );
}

function Portal({state, data, dispatch, api, strings, colors}) {
  switch (state) {
    case authorizing:
      return Message(stringMatching(strings, 'wait'));

    case unauthorized:
      return Login({dispatch, api, strings});

    case authorized:
      return EndPointBrowser({
        api: APIDefinition.enable({api, data}),
        strings,
        colors,
      });

    default:
      throw new Error('unrendered state');
  }
}

function Main({api}) {
  const [portal, dispatch] = useReducer(reducer, null, init);

  const props = {
    state: portal.state,
    data: portal.data,
    api,
    dispatch,
    strings: useStrings(),
    colors: useColors(),
  };

  return <Portal {...props} />;
}

export default Main;
